import { render, staticRenderFns } from "./baseButton.vue?vue&type=template&id=d64c109c&scoped=true&"
import script from "./baseButton.vue?vue&type=script&lang=js&"
export * from "./baseButton.vue?vue&type=script&lang=js&"
import style0 from "./baseButton.vue?vue&type=style&index=0&id=d64c109c&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d64c109c",
  null
  
)

export default component.exports